import {HTTP_CODES} from '@stubhub/general-utils';
import {getDomainName, parseUrl} from '@stubhub/sh-url-utils';

/**
 * Checks if the response contains a valid error based on HTTP status code and error code.
 * @param {Object} response The response object from an API request.
 * @returns {boolean} True if the response contains a valid error, false otherwise.
 */
export const hasValidError = (response) => {
  const responseJson = (response && response.body) || {};
  const {error} = responseJson;
  const {code: errorCode} = error || {};
  const responseStatus = response && response.status;

  return (
    responseStatus === HTTP_CODES.BAD_REQUEST ||
    (responseStatus === HTTP_CODES.UNAUTHORIZED &&
      errorCode === 'com.stubhub.domain.security.iam.services.exception.UnAuthorizedException') ||
    (responseStatus === HTTP_CODES.UNAUTHORIZED &&
      errorCode === 'com.stubhub.domain.security.iam.services.exception.InvalidSessionException')
  );
};

/**
 * Sets cookie data with specified name and value.
 * @param {Object} cookies The cookies object provided by a cookies library.
 * @param {string} name The name of the cookie.
 * @param {string} value The value to set for the cookie.
 */
export const setCookiesData = (cookies, name, value) => {
  let domain = '.';
  let protocol = '';
  if (__CLIENT__) {
    domain = getDomainName(window.location.href);
    ({protocol} = parseUrl(window.location.href));
  }
  cookies.set(name, value, {domain, path: '/', secure: protocol === 'https:'});
};

/**
 * Clears session-related cookies.
 * @param {Object} cookies The cookies object provided by a cookies library.
 */
export const clearSession = (cookies) => {
  cookies.remove('session_sessionId');
  cookies.remove('session_contactGUID');
  cookies.remove('session_loginStatus');
  cookies.remove('session_CSRFtoken');
  cookies.remove('session_userGUID');
};
